import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.padding.small};
`;

export const TextBlock = ({
  title,
  children,
}: React.PropsWithChildren<{ title?: string }>) => {
  return (
    <Container>
      {title && <h2>{title.toUpperCase()}</h2>}
      <Container>{children}</Container>
    </Container>
  );
};
